/**
 * ContentPageNavigation component for page content navigation
 * Migrated from front/src/components/ContentPageNavigation.js
 */

import React from 'react';
import {
  Dialog,
  Divider,
  Button,
  useMediaQuery
} from '@mui/material';
import { useTheme } from '@mui/material/styles';
import NestedList from './NestedList';

/**
 * ContentPageNavigation component
 * @param {Object} props - Component props
 * @param {Array} props.pageContentHierarchy - Hierarchy of page content
 * @param {Function} props.scrollTo - Function to scroll to element
 * @param {React.ReactNode} props.children - Child components for search dialog
 * @param {string} props.entityType - Type of entity
 * @param {Function} props.handleTableOfContentDialogClose - Handler for closing table dialog
 * @param {boolean} props.openTableOfContentDialog - Whether table dialog is open
 * @param {Function} props.handleSearchDialogClose - Handler for closing search dialog
 * @param {boolean} props.openSearchDialog - Whether search dialog is open
 * @returns {JSX.Element} ContentPageNavigation component
 */
const ContentPageNavigation = ({
  pageContentHierarchy,
  scrollTo,
  children,
  entityType,
  handleTableOfContentDialogClose,
  openTableOfContentDialog,
  handleSearchDialogClose,
  openSearchDialog,
}) => {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('md'));

  const tableOfContent = (
    <NestedList
      groups={pageContentHierarchy}
      scrollTo={scrollTo}
      entityType={entityType}
    />
  );

  return (
    <div className="hidden-print">
      {!isSmallScreen && tableOfContent}
      {isSmallScreen && (
        <>
          <Dialog
            disableRestoreFocus
            onClose={handleTableOfContentDialogClose}
            open={openTableOfContentDialog}
            sx={{ displayPrint: 'none' }}
          >
            {tableOfContent}
            <Divider />
            <Button
              variant="contained"
              sx={{ m: 2 }}
              onClick={handleTableOfContentDialogClose}
            >
              Valider la sélection
            </Button>
          </Dialog>

          <Dialog
            disableRestoreFocus
            fullWidth
            onClose={handleSearchDialogClose}
            open={openSearchDialog}
          >
            {children}
          </Dialog>
        </>
      )}
    </div>
  );
};

ContentPageNavigation.displayName = 'ContentPageNavigation';

export default ContentPageNavigation;
